<script>
import {Pie} from 'vue-chartjs';
import {mapState} from 'vuex';

export default({
    extends: Pie,
    props: {
        labels: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            colors: {
                available: '#51BB83',
                request: '#F4A830',
                blocked: '#D95A4B'
            }
        }
    },
    computed: {
        ...mapState({
            availability: state => state.dashboard.availability.items,
            accommodation: state => state.dashboard.availability.accommodation
        })
    },
    watch: {
        accommodation: {
            handler() {
                this.$data._chart.destroy();
                this.render();
            }
        }
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            this.renderChart({
                labels: this.labels,
                datasets: [
                    {
                        label: 'Availability',
                        backgroundColor: [
                            this.colors.available,
                            this.colors.request,
                            this.colors.blocked
                        ],
                        data: (this.accommodation) ? [
                            this.availability.accommodations[this.accommodation.value].available,
                            this.availability.accommodations[this.accommodation.value].request,
                            this.availability.accommodations[this.accommodation.value].blocked
                        ] : [
                            this.availability.available,
                            this.availability.request,
                            this.availability.blocked
                        ]
                    }
                ],
            },{
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        label: (item, data) => {
                            return this.labels[item.index] + ': ' + data.datasets[item.datasetIndex].data[item.index] + ' %';
                        }
                    }}
            }
            )
        }
    }
});
</script>



// WEBPACK FOOTER //
// src/components/DashboardAvailabilityGraph/DashboardAvailabilityGraph.vue